import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CellularPackagesBlockData from '../../../Models/Content/CellularPackagesBlockData';
import CellularPackageHolder from '../SaleBlock/CellularPackageHolder/CellularPackageHolder';

export default class CellularPackagesBlock extends EpiComponent<CellularPackagesBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CellularPackageHolder context={this.getContext()} contentData={this.props.data}/>;
  }
}
